import {
  MAutocomplete,
  MDatePicker,
  MTextField,
  ResponsiveFormContainer,
} from "@app/components";
import useAnalysis from "@app/pages/samples/utils/useAnalysis";
import { useReagents, useTypesUnits } from "@services/servicesGenericsTables";
import React, { useEffect } from "react";
import { useFormContext } from "react-hook-form";
import { TYPE_SR } from "./utils/constants";
import { Grid, Typography } from "@mui/material";
import useFilteredProcedures from "@app/pages/samples/hook/useFilteredProcedures";

const PrepararionGrossForm = () => {
  const form = useFormContext();
  const { currentPreparation } = useAnalysis();
  const filteredProcedures = useFilteredProcedures("PRE");
  const { reagentsList } = useReagents();
  const { typesUnitsis } = useTypesUnits();
  const regentSelected = form.watch("scintillator_lot_number");

  useEffect(() => {
    if (regentSelected) {
      form.setValue(
        "carrier_concentration",
        regentSelected.concentration || "",
        { shouldValidate: true }
      );
    }
  }, [regentSelected]);

  return (
    <>
      <Grid item xs={12} my={2}>
        <Typography variant="tagText">{TYPE_SR[0].label}</Typography>
      </Grid>
      <ResponsiveFormContainer columns={5}>
        <MAutocomplete
          key={JSON.stringify(form.getValues("preparation_procedure_gross"))}
          name="preparation_procedure_gross"
          options={filteredProcedures}
          label="Procedimiento MLPMA"
          getOptionLabel={(option) => `${option.numop}` || ""}
        />
        <MDatePicker
          name="start_date"
          pickerType="date"
          label={"Fecha de inicio"}
          validation={{
            required: "La fecha es requerida",
          }}
          disabled={!currentPreparation.canEdit}
        />
        <MTextField
          key={JSON.stringify(form.getValues("amount_ashes"))}
          name="amount_ashes"
          placeholder="Cantidad de cenizas"
          label="Cantidad de cenizas"
          type="number"
          fullWidth
          disabled={!currentPreparation.canEdit}
        />
        <MTextField
          key={JSON.stringify(form.getValues("amount_equivalent"))}
          name="amount_equivalent"
          placeholder="Cantidad equivalente"
          label="Cantidad equivalente"
          type="number"
          fullWidth
          disabled={!currentPreparation.canEdit}
        />
        <MAutocomplete
          key={JSON.stringify(form.getValues("scintillator_lot_number"))}
          name="scintillator_lot_number"
          options={reagentsList.filter(
            (reagent) =>
              reagent.end_date_use === null && reagent.start_date_use != null
          )}
          label="Seleccione Centelleador Nº de lote"
          getOptionLabel={(option) =>
            `${option.name}${
              option.number_lot ? ` - ${option.number_lot}` : ""
            } ${option.reactive_number ? ` - ${option.reactive_number}` : ""}
                          ${
                            !option.number_lot && !option.reactive_number
                              ? ` - Sin lote`
                              : ""
                          }`
          }
          disabled={!currentPreparation.canEdit}
        />

        <MTextField
          name="carrier_concentration"
          placeholder={"Concentración Portador"}
          label={"Concentración Portador"}
          type="text"
          fullWidth
          disabled
        />
        <MAutocomplete
          key={JSON.stringify(form.getValues("analysis_unit_types"))}
          name="analysis_unit_types"
          options={typesUnitsis}
          label="Seleccione un tipo de unidad"
          getOptionLabel={(option) =>
            `${option.codigo} | ${option.descripcion}`
          }
          validation={{ required: "El tipo de unidad es requerido" }}
          disabled={!currentPreparation.canEdit}
        />
        <MTextField
          key={JSON.stringify(form.getValues("valid_preparation"))}
          name="valid_preparation"
          placeholder="Preparación Válida"
          label="Preparación Válida"
          type="text"
          validation={{ required: "La preparación válida es requerida" }}
          fullWidth
          disabled
        />
      </ResponsiveFormContainer>
    </>
  );
};

export default PrepararionGrossForm;
